import React, { useState } from "react"
//import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"
import makeStyles from "@material-ui/core/styles/makeStyles"

import Button from "@material-ui/core/Button"
import DialogMui from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import FormControl from "@material-ui/core/FormControl"
import TextField from "@material-ui/core/TextField"
import InputAdornment from "@material-ui/core/InputAdornment"
import Badge from "@material-ui/core/Badge"
import Typography from "@material-ui/core/Typography"
import Box from "@material-ui/core/Box"
import Skeleton from "@material-ui/lab/Skeleton"
import DialogTitle from "@material-ui/core/DialogTitle"
import IconButton from "@material-ui/core/IconButton"
//import Switch from "@material-ui/core/Switch"
//import Grid from "@material-ui/core/Grid"

import CloseIcon from "@material-ui/icons/Close"
import AlternateEmailIcon from "@material-ui/icons/AlternateEmail"
import CheckCircleIcon from "@material-ui/icons/CheckCircle"

import AvatarInput from "./AvatarInput"
import { Alert, SuccessButton, UserRoleChip } from "components/widgets"
import { PasswordTextField } from "components/partials"
import { useAppSelector } from "common/hooks"
import { UsersApi } from "common/api"
import { LocalStorageKey } from "common/helpers"
import { useLocalStorage } from "common/hooks"
import { AuthActions } from "store/actions"

const useStyles = makeStyles(theme => ({
    info: {
        display: "flex",
        gap: theme.spacing(2)
    },

    verified: {
        backgroundColor: "#fff",
        borderRadius: "50%"
    },

    profile: {
        position: "relative"
    },

    header: {
        margin: 0,
        padding: theme.spacing(2),
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
    }
}))

const UserModal = props => {
    const { t } = useTranslation()

    const auth = useAppSelector(state => state.auth)
    const authActions = AuthActions.useActions()
    const [, setUserInLocalStorage] = useLocalStorage(LocalStorageKey.User)

    //const dispatch = useDispatch()
    const classes = useStyles()

    const [user, setUser] = useState(auth.user)
    const [isSaving, setIsSaving] = useState(false)
    const [alert, setAlert] = useState(null)

    function onClose() {
        if (props.onClose) {
            props.onClose({}, "backdropClick")
        }
    }

    const onChange = key => event => {
        if (user) {
            setUser({ ...user, [key]: event.target.value })
        }
    }

    function onChangeProfile(base64Image) {
        if (user) {
            setUser({ ...user, profileImage: base64Image })
        }
    }

    async function onSubmit(event) {
        event.preventDefault()

        if (!user) return

        try {
            setIsSaving(true)
            const response = await UsersApi.updateSelf(user)
            setUserInLocalStorage(response.data)
            authActions.login(response.data)
            setAlert({
                severity: "success",
                text: t("general.components.userModal.success")
            })
        } catch (error) {
            setAlert({
                severity: "error",
                text: t("general.components.userModal.error")
            })
        } finally {
            setIsSaving(false)
        }
    }

    function onExited() {
        setAlert(null)
        setUser(auth.user)
    }

    /* Logout deaktiviert
      async function onClickLogout() {
          // backward compatibility
          dispatch({ type: 'SET_TOKEN', payload: '' });
          dispatch({ type: 'USER_LOGOUT' });
  
          await AuthApi.logout();
          //history.replace('login');
      }
      */

    return (
        <DialogMui
            {...props}
            maxWidth="xs"
            TransitionProps={{
                onExited: onExited
            }}
        >
            <DialogTitle disableTypography className={classes.header}>
                <Typography variant="h6">
                    {t("general.components.userModal.title")}
                </Typography>

                <Box display="flex" style={{ columnGap: 8 }}>
                    <LanguageSwitch />
                    <IconButton edge="end" onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>

            <DialogContent>
                {alert && (
                    <Alert marginBottom={1} severity={alert.severity}>
                        {alert.text}
                    </Alert>
                )}

                <Box marginBottom={1}>
                    {user ? (
                        <Info user={user} onChangeProfile={onChangeProfile} />
                    ) : (
                        <InfoLoader />
                    )}
                </Box>

                <form onSubmit={onSubmit} id="user-form">
                    <FormControl fullWidth margin="normal">
                        <TextField
                            required
                            label={t("general.components.userModal.email")}
                            type="email"
                            autoComplete="username"
                            value={user?.email}
                            onChange={onChange("email")}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <AlternateEmailIcon />
                                    </InputAdornment>
                                )
                            }}
                        />
                    </FormControl>

                    <FormControl fullWidth margin="normal">
                        <PasswordTextField
                            isMasked={true}
                            value={user?.password || ""}
                            onChange={onChange("password")}
                            label={t("general.components.userModal.password")}
                            autoComplete="new-password"
                            CheckListProps={{
                                show: true
                            }}
                        />
                    </FormControl>
                </form>
            </DialogContent>

            <DialogActions>
                {/* Logout deaktiviert
                <DangerButton onClick={onClickLogout} style={{ marginRight: 'auto' }}>
                    {t('general.components.userModal.logout')}
                </DangerButton>
                */}
                <Button onClick={onClose}>
                    {t("general.components.userModal.cancel")}
                </Button>
                <SuccessButton
                    autoFocus
                    type="submit"
                    form="user-form"
                    disabled={isSaving}
                    variant="contained"
                    color="primary"
                >
                    {isSaving
                        ? t("general.components.userModal.submitButtonLoading")
                        : t("general.components.userModal.submitButton")}
                </SuccessButton>
            </DialogActions>
        </DialogMui>
    )
}

const LanguageSwitch = () => {

    return null;
    /*
        const app = useAppSelector(state => state.appV2)
        const appActions = AppActions.useActions()
    
        function onChangeLanguage() {
            appActions.toggleLanguage()
        }
    
        return (
            <Grid container component="label" alignItems="center">
                <Grid item>EN</Grid>
                <Grid item>
                    <Switch
                        name="language"
                        color="primary"
                        checked={app.language === "de"}
                        onChange={onChangeLanguage}
                    />
                </Grid>
                <Grid item>DE</Grid>
            </Grid>
        )
        */
}

const Info = props => {
    const classes = useStyles()
    const { user, onChangeProfile } = props
    const { fullName, role, verified, profileImage, company } = user

    return (
        <Box className={classes.info}>
            <Badge
                className={classes.profile}
                overlap="circular"
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right"
                }}
                badgeContent={
                    verified ? (
                        <Box className={classes.verified}>
                            <CheckCircleIcon color="primary" />
                        </Box>
                    ) : null
                }
            >
                <AvatarInput
                    onChange={onChangeProfile}
                    AvatarProps={{
                        alt: fullName,
                        src: profileImage || undefined
                    }}
                />
            </Badge>

            <Box>
                <Typography variant="h5">{fullName}</Typography>
                <Typography component="div" variant="body2" color="textSecondary">
                    <UserRoleChip role={role} />
                    {company && <>&nbsp;at&nbsp;</>}
                    {company ? (
                        <Typography
                            component="div"
                            variant="body2"
                            color="textPrimary"
                            style={{
                                marginTop: 3,
                                fontWeight: 500
                            }}
                        >
                            {company.name}
                        </Typography>
                    ) : null}
                </Typography>
            </Box>
        </Box>
    )
}

const InfoLoader = () => {
    const classes = useStyles()

    return (
        <Box className={classes.info}>
            <AvatarInput isLoading />

            <Box flexGrow={1}>
                <Skeleton variant="text" width="80%" height={40} />
                <Skeleton variant="text" width="40%" />
            </Box>
        </Box>
    )
}

export default UserModal
